export default {"src":"/_next/static/media/deposit_offer_custom_label_pink.bcb04a41.svg","height":28,"width":78,"blurWidth":0,"blurHeight":0};